import { useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useOutletContext, useParams } from "react-router";
import { showError, showSuccess } from "../../services/toast-service";
import { updateFunnelReclaimModeSettings } from "../../services/api-declaration";
import { useTranslation } from "react-i18next";

const ReclaimMode = ({ toggleCb }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { funnel } = useOutletContext();

  const [enabled, setEnabled] = useState(funnel?.reclaimMode || false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleToggle = async (checked) => {
    try {
      setIsSubmitting(true);
      setEnabled(checked);
      const body = { reclaimMode: checked };
      const response = await updateFunnelReclaimModeSettings({ id, body });
      showSuccess(response.data.message);
      toggleCb(checked);
    } catch (error) {
      setEnabled(!checked); // revert UI
      showError(t("common.somethingWentWrong"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="px-3 py-2">
      <div className="d-flex align-items-center justify-content-between">
        <Form.Check
          id="reclaim-mode"
          type="switch"
          label={t("funnelIntegration.reclaimMode.checkboxLabel")}
          checked={enabled}
          disabled={isSubmitting}
          onChange={({ target: { checked } }) => handleToggle(checked)}
        />
        {isSubmitting && <Spinner animation="border" size="sm" />}
      </div>

      <small className="text-muted d-block mt-1">
        Allow users with blocked postal codes to continue and capture their
        leads internally.
      </small>
    </div>
  );
};

export default ReclaimMode;
